module.exports = __webpack_public_path__ + "static/media/trioultimefr.83565827.png";